import { type ConversationMetadata } from 'TutorBotChat';
import { type AnyObject } from '@Types';
import { UI_CONTEXT_REVIEW_LESSON_AUDIO, UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL_AUDIO } from 'TutorBotConversation';
import {
    type LessonPlayerBotChatUiContext,
    type LessonPlayerBotUiContext,
    type LessonPlayerBotAudioUiContext,
    type ContentInfoForReviewLessonUiContext,
    type ContentInfoForReviewPreviousMaterialUiContext,
    type LessonPlayerBotContentInfo,
    type LessonPlayerConversationMetadata,
    type ContentInfoForLessonPlayerAlgorithm,
} from '../TutorBotAiTutorChat.types';

export function isLessonPlayerConversationMetadata(
    conversationMetadata: ConversationMetadata,
): conversationMetadata is LessonPlayerConversationMetadata {
    return 'frameId' in conversationMetadata;
}

export function isContentInfoForReviewPreviousMaterialUiContext(
    contentInfo: LessonPlayerBotContentInfo,
): contentInfo is ContentInfoForReviewPreviousMaterialUiContext {
    if ('targetLesson' in contentInfo && contentInfo.targetLesson !== 'previous_lesson') return false;
    if (!contentInfo.lessonId) return false;
    if (!contentInfo.streamId) return false;
    if (!('targetLessonId' in contentInfo)) return false;

    return true;
}

export function isContentInfoForReviewLessonUiContent(
    contentInfo: LessonPlayerBotContentInfo,
): contentInfo is ContentInfoForReviewLessonUiContext {
    const obj = contentInfo as AnyObject;
    if (obj.targetLesson !== 'this_lesson') return false;
    if (typeof obj.lessonId !== 'string') return false;
    if (typeof obj.streamId !== 'string') return false;
    return true;
}

export function isContentInfoForLessonPlayerAlgorithm(
    contentInfo: LessonPlayerBotContentInfo,
): contentInfo is ContentInfoForLessonPlayerAlgorithm {
    if (!contentInfo.lessonId) return false;
    if (!('lessonTitle' in contentInfo)) return false;
    if (!contentInfo.lessonVersionId) return false;

    return true;
}

export function isAudioUiContext(uiContext: LessonPlayerBotUiContext): uiContext is LessonPlayerBotAudioUiContext {
    return uiContext === UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL_AUDIO || uiContext === UI_CONTEXT_REVIEW_LESSON_AUDIO;
}

export function isChatUiContext(uiContext: LessonPlayerBotUiContext): uiContext is LessonPlayerBotChatUiContext {
    return !isAudioUiContext(uiContext);
}
